var BUTAN_YM1A = {
  name: "BUTAN YM1A",
  defaultCommandIndex: 1,
  commands: [
		{
			mode: "AC_MODE_OFF",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_NULL",
			command: [73,0,4,195,2,220,1,185,2,74,6,106,35,67,17,191,2,0,0,47,253,255,255,183,96],
		},
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,161,2,235,1,187,2,82,6,61,35,41,17,202,2,0,0,46,255,255,255,183,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,188,2,207,1,85,35,15,17,212,2,33,6,217,2,0,0,78,124,255,255,243,57,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,196,2,192,1,108,35,248,16,226,2,26,6,224,2,0,0,78,126,127,255,243,57,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,199,2,185,1,108,35,230,16,248,2,29,6,222,2,0,0,78,124,159,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,202,2,185,1,111,35,247,16,224,2,17,6,212,2,0,0,78,127,63,255,243,57,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,212,2,181,1,113,35,253,16,226,2,19,6,225,2,0,0,78,124,207,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,193,2,186,1,111,35,2,17,222,2,34,6,218,2,0,0,78,126,79,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,209,2,187,1,104,35,2,17,220,2,20,6,222,2,0,0,78,124,147,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,196,2,169,1,107,35,0,17,221,2,35,6,247,2,0,0,78,127,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,193,2,182,1,108,35,246,16,227,2,38,6,224,2,0,0,78,124,231,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,183,2,191,1,100,35,228,16,248,2,42,6,223,2,0,0,78,126,103,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,230,2,161,1,119,35,252,16,221,2,244,5,230,2,0,0,78,124,153,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,217,2,183,1,111,35,248,16,228,2,13,6,236,2,0,0,78,127,39,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,218,2,183,1,115,35,243,16,229,2,10,6,231,2,0,0,78,124,201,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,196,2,184,1,109,35,250,16,225,2,36,6,223,2,0,0,78,126,73,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [73,0,4,214,2,180,1,110,35,244,16,234,2,12,6,234,2,0,0,78,79,255,255,243,57,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [73,0,4,193,2,189,1,113,35,252,16,226,2,35,6,211,2,0,0,78,79,63,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [73,0,4,217,2,176,1,119,35,251,16,225,2,8,6,227,2,0,0,78,79,159,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [73,0,4,211,2,183,1,120,35,244,16,229,2,14,6,228,2,0,0,78,79,39,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [73,0,4,210,2,183,1,116,35,251,16,223,2,23,6,228,2,0,0,78,79,207,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [73,0,4,210,2,183,1,108,35,5,17,219,2,20,6,226,2,0,0,78,79,51,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [73,0,4,199,2,184,1,117,35,250,16,224,2,31,6,216,2,0,0,78,79,147,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [73,0,4,200,2,186,1,118,35,243,16,228,2,23,6,220,2,0,0,78,79,36,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [73,0,4,215,2,182,1,138,35,255,16,222,2,16,6,222,2,0,0,78,79,231,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [73,0,4,185,2,194,1,109,35,8,17,211,2,40,6,195,2,0,0,78,79,57,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [73,0,4,201,2,184,1,135,35,246,16,227,2,27,6,227,2,0,0,78,79,153,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [73,0,4,212,2,183,1,114,35,252,16,226,2,18,6,226,2,0,0,78,79,38,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [73,0,4,187,2,186,1,112,35,1,17,218,2,38,6,218,2,0,0,78,79,201,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [73,0,4,217,2,186,1,113,35,0,17,222,2,10,6,250,2,0,0,78,79,50,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [73,0,4,209,2,187,1,113,35,251,16,222,2,21,6,221,2,0,0,78,79,146,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [73,0,4,152,2,234,1,79,35,27,17,194,2,68,6,180,2,0,0,78,103,255,255,243,57,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [73,0,4,180,2,198,1,131,35,10,17,209,2,47,6,199,2,0,0,78,103,63,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [73,0,4,181,2,204,1,94,35,9,17,212,2,46,6,191,2,0,0,78,103,159,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [73,0,4,206,2,189,1,105,35,250,16,222,2,18,6,227,2,0,0,78,103,39,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [73,0,4,180,2,208,1,92,35,19,17,211,2,46,6,182,2,0,0,78,103,207,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [73,0,4,193,2,204,1,104,35,11,17,216,2,27,6,195,2,0,0,78,103,51,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [73,0,4,197,2,198,1,202,2,60,6,108,35,254,16,213,2,0,0,46,222,191,255,246,236,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [73,0,4,197,2,185,1,115,35,2,17,210,2,31,6,224,2,0,0,78,103,36,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [73,0,4,217,2,157,1,102,35,250,16,228,2,15,6,230,2,0,0,78,103,231,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [73,0,4,200,2,187,1,133,35,249,16,222,2,28,6,215,2,0,0,78,103,57,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [73,0,4,214,2,182,1,131,35,249,16,227,2,18,6,224,2,0,0,78,103,153,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [73,0,4,207,2,187,1,115,35,243,16,226,2,17,6,226,2,0,0,78,103,38,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [73,0,4,209,2,184,1,106,35,249,16,224,2,21,6,224,2,0,0,78,103,201,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [73,0,4,218,2,185,1,114,35,245,16,227,2,11,6,232,2,0,0,78,103,50,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [73,0,4,185,2,192,1,107,35,249,16,222,2,30,6,210,2,0,0,78,103,146,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,202,2,185,1,105,35,220,16,2,3,21,6,224,2,0,0,78,73,255,255,252,206,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,216,2,179,1,115,35,244,16,228,2,19,6,229,2,0,0,78,73,207,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,216,2,185,1,115,35,253,16,221,2,12,6,229,2,0,0,78,73,231,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,221,2,183,1,103,35,242,16,231,2,1,6,2,3,0,0,78,73,201,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,193,2,185,1,110,35,8,17,219,2,39,6,254,2,0,0,78,73,243,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,210,2,161,1,106,35,252,16,225,2,20,6,217,2,0,0,78,73,204,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,214,2,179,1,116,35,251,16,224,2,19,6,227,2,0,0,78,73,228,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,218,2,182,1,114,35,251,16,224,2,14,6,227,2,0,0,78,73,201,63,255,243,57,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,218,2,184,1,112,35,245,16,226,2,14,6,229,2,0,0,78,73,249,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,204,2,162,1,114,35,248,16,225,2,22,6,231,2,0,0,78,73,206,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,210,2,191,1,117,35,0,17,217,2,12,6,218,2,0,0,78,73,230,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,216,2,187,1,112,35,254,16,218,2,12,6,229,2,0,0,78,73,201,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,211,2,178,1,112,35,255,16,219,2,24,6,254,2,0,0,78,73,242,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,196,2,191,1,135,35,246,16,226,2,25,6,217,2,0,0,78,73,204,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,214,2,186,1,137,35,247,16,222,2,19,6,232,2,0,0,78,73,228,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,208,2,184,1,111,35,3,17,225,2,37,6,199,2,0,0,114,127,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,209,2,187,1,115,35,242,16,225,2,40,6,212,2,0,0,114,124,255,255,243,57,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,205,2,190,1,115,35,255,16,223,2,38,6,223,2,0,0,114,126,127,255,243,57,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,220,2,177,1,113,35,245,16,229,2,10,6,233,2,0,0,114,124,159,255,252,206,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,208,2,187,1,115,35,2,17,215,2,34,6,236,2,0,0,114,127,63,255,243,57,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,177,2,226,1,105,35,33,17,191,2,50,6,193,2,0,0,114,124,207,255,252,206,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,109,35,251,16,221,2,154,1,230,2,12,6,237,2,0,0,169,42,169,42,170,170,170,169,74,148,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,219,2,179,1,114,35,243,16,241,2,14,6,7,3,0,0,114,124,147,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,206,2,185,1,143,35,255,16,245,2,37,6,214,2,0,0,114,127,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,219,2,185,1,117,35,238,16,225,2,37,6,221,2,0,0,114,124,231,255,252,206,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,215,2,178,1,114,35,248,16,227,2,18,6,223,2,0,0,114,126,103,255,252,206,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,217,2,174,1,107,35,251,16,228,2,37,6,220,2,0,0,114,124,153,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,217,2,183,1,108,35,244,16,219,2,40,6,213,2,0,0,114,127,39,255,252,206,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,214,2,184,1,110,35,254,16,235,2,24,6,218,2,0,0,114,124,201,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,215,2,178,1,111,35,249,16,223,2,26,6,222,2,0,0,114,126,73,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [73,0,4,208,2,193,1,112,35,248,16,251,2,36,6,208,2,0,0,114,79,255,255,243,57,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [73,0,4,218,2,154,1,109,35,252,16,223,2,17,6,249,2,0,0,114,79,63,255,252,206,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [73,0,4,218,2,159,1,118,35,246,16,223,2,13,6,224,2,0,0,114,79,159,255,252,206,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [73,0,4,210,2,182,1,112,35,8,17,223,2,32,6,218,2,0,0,114,79,39,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [73,0,4,217,2,178,1,107,35,247,16,219,2,19,6,227,2,0,0,114,79,207,255,252,206,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [73,0,4,223,2,181,1,108,35,247,16,216,2,12,6,228,2,0,0,114,79,51,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [73,0,4,214,2,191,1,107,35,253,16,253,2,34,6,219,2,0,0,114,79,147,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [73,0,4,242,2,162,1,133,35,243,16,245,2,246,5,228,2,0,0,114,79,36,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [73,0,4,215,2,185,1,135,35,248,16,220,2,36,6,224,2,0,0,114,79,231,255,252,206,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [73,0,4,203,2,196,1,107,35,6,17,229,2,23,6,209,2,0,0,114,79,57,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [73,0,4,208,2,195,1,103,35,4,17,227,2,32,6,215,2,0,0,114,79,153,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [73,0,4,108,35,252,16,212,2,184,1,221,2,39,6,214,2,0,0,169,37,82,82,170,170,170,170,82,165,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [73,0,4,205,2,192,1,101,35,4,17,222,2,35,6,199,2,0,0,114,79,201,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [73,0,4,104,35,1,17,207,2,200,1,233,2,36,6,222,2,0,0,169,37,82,146,170,170,170,170,82,165,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [73,0,4,213,2,189,1,108,35,255,16,219,2,35,6,224,2,0,0,114,79,146,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [73,0,4,199,2,205,1,99,35,0,17,225,2,27,6,206,2,0,0,114,103,255,255,243,57,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [73,0,4,213,2,183,1,107,35,253,16,223,2,34,6,217,2,0,0,114,103,63,255,252,206,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [73,0,4,207,2,191,1,139,35,0,17,232,2,26,6,211,2,0,0,114,103,159,255,252,206,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [73,0,4,208,2,194,1,105,35,254,16,253,2,36,6,202,2,0,0,114,103,39,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [73,0,4,215,2,176,1,112,35,251,16,246,2,36,6,221,2,0,0,114,103,207,255,252,206,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [73,0,4,211,2,186,1,104,35,255,16,225,2,37,6,218,2,0,0,114,103,51,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [73,0,4,215,2,187,1,119,35,253,16,223,2,20,6,208,2,0,0,114,103,147,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [73,0,4,213,2,181,1,116,35,250,16,221,2,36,6,214,2,0,0,114,103,36,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [73,0,4,215,2,186,1,115,35,252,16,219,2,18,6,233,2,0,0,114,103,231,255,252,206,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [73,0,4,211,2,185,1,104,35,250,16,219,2,39,6,213,2,0,0,114,103,57,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [73,0,4,217,2,160,1,136,35,247,16,221,2,24,6,217,2,0,0,114,103,153,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [73,0,4,115,35,253,16,211,2,182,1,237,2,20,6,227,2,0,0,169,41,82,82,170,170,170,170,82,165,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [73,0,4,217,2,181,1,114,35,247,16,223,2,8,6,234,2,0,0,114,103,201,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [73,0,4,136,35,252,16,217,2,181,1,224,2,15,6,229,2,0,0,169,41,82,146,170,170,170,170,82,165,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [73,0,4,206,2,186,1,101,35,2,17,232,2,27,6,218,2,0,0,114,103,146,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,197,2,207,1,96,35,5,17,220,2,20,6,205,2,0,0,114,73,255,255,252,206,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,212,2,163,1,132,35,251,16,226,2,38,6,213,2,0,0,114,73,207,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,213,2,188,1,106,35,253,16,221,2,41,6,230,2,0,0,114,73,231,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,216,2,180,1,106,35,248,16,221,2,23,6,220,2,0,0,114,73,201,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,216,2,179,1,107,35,249,16,218,2,16,6,234,2,0,0,114,73,243,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,218,2,178,1,112,35,253,16,237,2,20,6,224,2,0,0,114,73,204,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,210,2,191,1,108,35,251,16,220,2,23,6,218,2,0,0,114,73,228,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,216,2,181,1,131,35,247,16,215,2,23,6,227,2,0,0,114,73,201,63,255,243,57,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,218,2,184,1,122,35,247,16,221,2,23,6,230,2,0,0,114,73,249,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,213,2,184,1,108,35,0,17,219,2,16,6,230,2,0,0,114,73,206,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,192,2,207,1,110,35,12,17,232,2,25,6,206,2,0,0,114,73,230,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,219,2,164,1,112,35,248,16,225,2,15,6,230,2,0,0,114,73,201,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,212,2,186,1,139,35,0,17,220,2,243,5,226,2,0,0,114,73,242,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,212,2,182,1,114,35,249,16,218,2,14,6,233,2,0,0,114,73,204,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,202,2,179,1,113,35,8,17,221,2,25,6,206,2,0,0,114,73,228,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,190,2,207,1,99,35,7,17,218,2,38,6,207,2,0,0,121,243,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_LOW",
      command: [73,0,4,188,2,218,1,87,35,19,17,192,2,48,6,215,2,0,0,121,60,231,255,252,206,98],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_MID",
      command: [73,0,4,200,2,205,1,97,35,2,17,241,2,49,6,196,2,0,0,121,156,231,255,252,206,98],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,69,35,40,17,172,2,232,1,179,2,63,6,212,2,0,0,170,73,82,165,85,85,85,84,165,74,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,99,35,7,17,205,2,196,1,225,2,17,6,208,2,0,0,165,42,170,170,170,170,170,165,42,81,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,207,2,187,1,114,35,250,16,241,2,12,6,216,2,0,0,102,124,255,255,243,57,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,110,35,250,16,215,2,187,1,215,2,10,6,224,2,0,0,165,42,169,85,85,85,85,82,149,40,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,217,2,157,1,110,35,248,16,254,2,20,6,254,2,0,0,102,124,159,255,252,206,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,212,2,181,1,104,35,251,16,238,2,26,6,213,2,0,0,102,127,63,255,243,57,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,223,2,172,1,110,35,250,16,230,2,19,6,3,3,0,0,102,124,207,255,252,206,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,215,2,183,1,111,35,1,17,221,2,13,6,233,2,0,0,102,126,79,255,252,206,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,221,2,165,1,113,35,244,16,245,2,13,6,230,2,0,0,102,124,147,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,214,2,160,1,108,35,253,16,249,2,13,6,235,2,0,0,102,127,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,219,2,178,1,110,35,249,16,229,2,4,6,226,2,0,0,102,124,231,255,252,206,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,219,2,156,1,112,35,242,16,252,2,9,6,226,2,0,0,102,126,103,255,252,206,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,222,2,183,1,110,35,245,16,222,2,11,6,232,2,0,0,102,124,153,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,218,2,183,1,141,35,245,16,219,2,15,6,6,3,0,0,102,127,39,255,252,206,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,221,2,181,1,111,35,249,16,228,2,8,6,232,2,0,0,102,124,201,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,195,2,211,1,95,35,15,17,215,2,24,6,190,2,0,0,102,126,73,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [73,0,4,215,2,182,1,140,35,246,16,226,2,19,6,232,2,0,0,102,79,255,255,243,57,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [73,0,4,105,35,248,16,217,2,183,1,229,2,32,6,241,2,0,0,165,37,82,170,170,170,170,169,74,148,64],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [73,0,4,220,2,181,1,110,35,247,16,234,2,10,6,227,2,0,0,102,79,159,255,252,206,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [73,0,4,108,35,246,16,220,2,181,1,236,2,6,6,251,2,0,0,165,37,82,85,85,85,85,84,165,74,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [73,0,4,220,2,182,1,112,35,242,16,234,2,3,6,230,2,0,0,102,79,207,255,252,206,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [73,0,4,133,35,247,16,221,2,182,1,221,2,18,6,225,2,0,0,165,37,82,149,85,85,85,84,165,74,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [73,0,4,217,2,181,1,105,35,7,17,226,2,4,6,235,2,0,0,102,79,147,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [73,0,4,108,35,250,16,219,2,182,1,228,2,7,6,231,2,0,0,165,37,82,74,170,170,170,170,82,165,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [73,0,4,221,2,181,1,112,35,250,16,221,2,8,6,228,2,0,0,102,79,231,255,252,206,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [73,0,4,136,35,250,16,220,2,176,1,227,2,9,6,243,2,0,0,165,37,82,165,85,85,85,84,165,74,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [73,0,4,220,2,176,1,115,35,251,16,229,2,14,6,234,2,0,0,102,79,153,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [73,0,4,118,35,247,16,222,2,186,1,207,2,15,6,206,2,0,0,165,37,82,82,170,170,170,170,82,165,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [73,0,4,217,2,182,1,110,35,252,16,237,2,12,6,233,2,0,0,102,79,201,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [73,0,4,112,35,248,16,219,2,179,1,232,2,13,6,247,2,0,0,165,37,82,146,170,170,170,170,82,165,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [73,0,4,219,2,180,1,106,35,255,16,235,2,8,6,233,2,0,0,102,79,146,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [73,0,4,208,2,188,1,117,35,251,16,239,2,17,6,207,2,0,0,102,103,255,255,243,57,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [73,0,4,224,2,180,1,114,35,248,16,228,2,11,6,225,2,0,0,102,103,63,255,252,206,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [73,0,4,222,2,179,1,113,35,244,16,227,2,15,6,6,3,0,0,102,103,159,255,252,206,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [73,0,4,227,2,174,1,114,35,244,16,221,2,12,6,232,2,0,0,102,103,39,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [73,0,4,226,2,177,1,118,35,242,16,221,2,13,6,252,2,0,0,102,103,207,255,252,206,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [73,0,4,224,2,180,1,118,35,245,16,223,2,247,5,223,2,0,0,102,103,51,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [73,0,4,219,2,180,1,116,35,254,16,226,2,8,6,232,2,0,0,102,103,147,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [73,0,4,223,2,179,1,108,35,244,16,226,2,18,6,233,2,0,0,102,103,36,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [73,0,4,223,2,176,1,114,35,252,16,228,2,12,6,233,2,0,0,102,103,231,255,252,206,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [73,0,4,222,2,175,1,120,35,242,16,226,2,12,6,230,2,0,0,102,103,57,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [73,0,4,220,2,178,1,111,35,255,16,232,2,13,6,232,2,0,0,102,103,153,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [73,0,4,219,2,171,1,115,35,249,16,232,2,14,6,231,2,0,0,102,103,38,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [73,0,4,225,2,177,1,128,35,244,16,227,2,16,6,238,2,0,0,102,103,201,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [73,0,4,232,2,179,1,112,35,224,16,230,2,1,6,222,2,0,0,102,103,50,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [73,0,4,218,2,161,1,146,35,251,16,245,2,16,6,224,2,0,0,102,103,146,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,218,2,181,1,116,35,248,16,239,2,8,6,250,2,0,0,102,73,255,255,252,206,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,215,2,185,1,113,35,255,16,237,2,5,6,214,2,0,0,102,73,207,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,219,2,179,1,113,35,251,16,228,2,16,6,252,2,0,0,102,73,231,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,217,2,180,1,138,35,245,16,227,2,14,6,226,2,0,0,102,73,201,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,222,2,175,1,115,35,250,16,240,2,1,6,226,2,0,0,102,73,243,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,238,2,180,1,114,35,217,16,225,2,5,6,253,2,0,0,102,73,204,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,214,2,181,1,113,35,254,16,222,2,5,6,230,2,0,0,102,73,228,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,221,2,175,1,112,35,245,16,231,2,9,6,226,2,0,0,102,73,201,63,255,243,57,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,219,2,182,1,110,35,254,16,226,2,12,6,229,2,0,0,102,73,249,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,217,2,183,1,102,35,251,16,238,2,19,6,230,2,0,0,102,73,206,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,215,2,183,1,112,35,247,16,234,2,13,6,221,2,0,0,102,73,230,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,218,2,180,1,116,35,248,16,226,2,10,6,249,2,0,0,102,73,201,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,218,2,186,1,139,35,248,16,224,2,239,5,228,2,0,0,102,73,242,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,212,2,182,1,112,35,250,16,239,2,4,6,224,2,0,0,102,73,204,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,214,2,183,1,112,35,254,16,235,2,8,6,225,2,0,0,102,73,228,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,221,2,38,6,105,35,254,16,192,2,189,1,221,2,0,0,115,36,146,73,36,146,73,36,146,73,153,50,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,227,2,36,6,112,35,246,16,191,2,187,1,212,2,0,0,115,36,153,36,146,73,36,146,73,38,100,200,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,219,2,24,6,126,35,0,17,188,2,190,1,205,2,0,0,115,36,147,36,146,73,36,146,73,38,100,200,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,222,2,30,6,110,35,255,16,185,2,193,1,200,2,0,0,115,36,156,146,73,36,146,73,36,153,147,34],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,220,2,30,6,124,35,255,16,187,2,190,1,206,2,0,0,115,36,146,100,146,73,36,146,73,38,100,200,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,250,2,40,6,131,35,215,16,184,2,190,1,217,2,0,0,115,36,153,146,73,36,146,73,36,153,147,34],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,217,2,24,6,106,35,4,17,184,2,189,1,216,2,0,0,115,36,147,146,73,36,146,73,36,153,147,34],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,223,2,20,6,141,35,251,16,205,2,186,1,231,2,0,0,115,36,158,73,36,146,73,36,146,102,76,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,224,2,20,6,108,35,251,16,192,2,186,1,233,2,0,0,115,36,146,76,146,73,36,146,73,38,100,200,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,223,2,34,6,109,35,252,16,210,2,170,1,227,2,0,0,115,36,153,50,73,36,146,73,36,153,147,34],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,245,2,22,6,127,35,227,16,204,2,187,1,222,2,0,0,115,36,147,50,73,36,146,73,36,153,147,34],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,224,2,37,6,113,35,248,16,181,2,196,1,202,2,0,0,115,36,156,201,36,146,73,36,146,102,76,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,222,2,28,6,107,35,251,16,191,2,188,1,222,2,0,0,115,36,146,114,73,36,146,73,36,153,147,34],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,221,2,23,6,117,35,250,16,191,2,187,1,220,2,0,0,115,36,153,201,36,146,73,36,146,102,76,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [73,0,4,252,2,13,6,106,35,223,16,230,2,154,1,227,2,0,0,115,36,147,201,36,146,73,36,146,102,76,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [73,0,4,227,2,18,6,110,35,245,16,193,2,184,1,216,2,0,0,115,146,73,36,146,73,36,146,73,38,100,200,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [73,0,4,223,2,21,6,113,35,250,16,181,2,193,1,188,2,0,0,115,146,100,146,73,36,146,73,36,153,147,34],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [73,0,4,220,2,26,6,107,35,253,16,188,2,186,1,238,2,0,0,115,146,76,146,73,36,146,73,36,153,147,34],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [73,0,4,222,2,40,6,109,35,251,16,180,2,199,1,216,2,0,0,115,146,114,73,36,146,73,36,146,102,76,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [73,0,4,225,2,13,6,113,35,249,16,216,2,184,1,230,2,0,0,115,146,73,146,73,36,146,73,36,153,147,34],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [73,0,4,225,2,14,6,106,35,249,16,219,2,184,1,235,2,0,0,115,146,102,73,36,146,73,36,146,102,76,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [73,0,4,224,2,18,6,111,35,254,16,213,2,181,1,235,2,0,0,115,146,78,73,36,146,73,36,146,102,76,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [73,0,4,229,2,8,6,110,35,246,16,219,2,176,1,12,3,0,0,115,146,121,36,146,73,36,146,73,153,50,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [73,0,4,208,2,37,6,101,35,0,17,180,2,200,1,209,2,0,0,115,146,73,50,73,36,146,73,36,153,147,34],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [73,0,4,222,2,39,6,107,35,247,16,181,2,191,1,225,2,0,0,115,146,100,201,36,146,73,36,146,102,76,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [73,0,4,218,2,24,6,115,35,248,16,182,2,193,1,216,2,0,0,115,146,76,201,36,146,73,36,146,102,76,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [73,0,4,227,2,15,6,140,35,243,16,217,2,180,1,249,2,0,0,115,146,115,36,146,73,36,146,73,153,50,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [73,0,4,223,2,11,6,115,35,253,16,219,2,178,1,226,2,0,0,115,146,73,201,36,146,73,36,146,102,76,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [73,0,4,224,2,8,6,111,35,250,16,217,2,178,1,236,2,0,0,115,146,103,36,146,73,36,146,73,153,50,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [73,0,4,225,2,16,6,107,35,250,16,218,2,181,1,226,2,0,0,115,146,79,36,146,73,36,146,73,153,50,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [73,0,4,156,2,230,1,66,35,42,17,176,2,68,6,199,2,0,0,73,153,255,255,252,206,98],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [73,0,4,184,2,192,1,108,35,251,16,226,2,29,6,220,2,0,0,73,153,207,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [73,0,4,193,2,184,1,110,35,253,16,222,2,21,6,221,2,0,0,73,153,231,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [73,0,4,186,2,187,1,112,35,249,16,219,2,26,6,221,2,0,0,73,153,201,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [73,0,4,202,2,186,1,99,35,255,16,223,2,20,6,224,2,0,0,73,153,243,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [73,0,4,217,2,167,1,132,35,250,16,227,2,8,6,229,2,0,0,73,153,204,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [73,0,4,213,2,182,1,111,35,245,16,227,2,20,6,224,2,0,0,73,153,228,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [73,0,4,214,2,159,1,112,35,247,16,226,2,8,6,229,2,0,0,73,153,201,63,255,243,57,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [73,0,4,191,2,172,1,115,35,218,16,252,2,13,6,228,2,0,0,73,153,249,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [73,0,4,201,2,185,1,129,35,249,16,224,2,20,6,225,2,0,0,73,153,206,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [73,0,4,224,2,179,1,122,35,1,17,221,2,9,6,230,2,0,0,73,153,230,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [73,0,4,212,2,182,1,115,35,244,16,231,2,14,6,231,2,0,0,73,153,201,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [73,0,4,219,2,178,1,107,35,0,17,222,2,8,6,235,2,0,0,73,153,242,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [73,0,4,218,2,182,1,141,35,227,16,241,2,14,6,235,2,0,0,73,153,204,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [73,0,4,201,2,185,1,114,35,248,16,223,2,15,6,219,2,0,0,73,153,228,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,182,2,195,1,106,35,2,17,212,2,44,6,212,2,0,0,73,146,127,255,255,51,152,128],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,204,2,183,1,108,35,2,17,219,2,10,6,221,2,0,0,73,146,115,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,215,2,177,1,127,35,251,16,225,2,10,6,240,2,0,0,73,146,121,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,214,2,179,1,115,35,250,16,222,2,13,6,228,2,0,0,73,146,114,127,255,243,57,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,219,2,181,1,118,35,243,16,228,2,11,6,228,2,0,0,73,146,124,255,255,204,230,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,220,2,179,1,116,35,248,16,223,2,14,6,227,2,0,0,73,146,115,63,255,243,57,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,222,2,172,1,116,35,220,16,248,2,235,5,229,2,0,0,73,146,121,63,255,243,57,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,218,2,180,1,115,35,248,16,227,2,14,6,4,3,0,0,73,146,114,79,255,252,206,98],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,220,2,180,1,113,35,247,16,226,2,17,6,230,2,0,0,73,146,126,127,255,204,230,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,220,2,182,1,116,35,219,16,250,2,243,5,235,2,0,0,73,146,115,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,216,2,178,1,113,35,245,16,227,2,14,6,252,2,0,0,73,146,121,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,225,2,181,1,120,35,250,16,225,2,8,6,234,2,0,0,73,146,114,103,255,252,206,98],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,204,2,185,1,106,35,255,16,219,2,22,6,222,2,0,0,73,146,124,159,255,243,57,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,196,2,182,1,107,35,255,16,217,2,19,6,241,2,0,0,73,146,115,39,255,252,206,98],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [73,0,4,215,2,180,1,146,35,4,17,217,2,12,6,233,2,0,0,73,146,121,39,255,252,206,98],
    },
    ]
};

export default BUTAN_YM1A
